module.exports = [
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 48.1
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 38.8
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 40.13
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": null
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": null
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 41.73
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 34.5
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 33.33
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 31.17
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 29.47
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 27.73
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 26.03
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 24.73
  },
  {
    "AgeGroup": "1-4 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 24.15
  }
]
